import React, { useState } from "react";
import { Modal, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import useGenericFormModal from "./useGenericModal";
import Loader from "../../Common/Loader";


export function useFormModal({ FormContent, size = null }) {
    const [Modal, actions] = useGenericFormModal({
        ModalComponent: ({ state }) => (<FormModalComponent size={size} state={{ ...state, configuration: { ...state.configuration, FormContent: FormContent } }}> </FormModalComponent>)
    })

    return [Modal, actions]
}

function FormModalComponent({ size, state: { show, isLoading, onClose, onConfirmation, configuration: { title, FormContent }, initValue = null } }) {
    const { t } = useTranslation();

    return (
        <Modal show={show} onHide={onClose} bsSize={size}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormContent handleSubmit={onConfirmation} initValue={initValue} />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>{t('buttons.close')}</Button>
            </Modal.Footer>
        </Modal >
    )
}  